import { render } from "./FilterInfo.vue?vue&type=template&id=23581666"
import script from "./FilterInfo.vue?vue&type=script&lang=js"
export * from "./FilterInfo.vue?vue&type=script&lang=js"

import "./FilterInfo.vue?vue&type=style&index=0&id=23581666&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__